"use client";

import { FC, PropsWithChildren, useContext } from "react";
import { TranslationScopes } from "@finbackoffice/enums";
import classNames from "classnames";
import { ModalsContextV2 } from "contexts";
import Translate from "components/base/translate/Translate";
import { Svg } from "components/base/svg/Svg";
import styles from "./account-header.module.sass";

type IProps = {
    onClick?: () => void;
    className?: string;
    headingIcon?: string;
    tId?: string;
    titleStrongText?: string;
    hideTitle?: boolean;
};

const AccountHeader: FC<IProps & PropsWithChildren> = ({
    onClick,
    className,
    headingIcon,
    tId,
    titleStrongText,
    children,
}) => {
    const { accountModalRef } = useContext(ModalsContextV2);

    return (
        <div className={classNames(styles.header, className)}>
            <div
                onClick={() => {
                    onClick && onClick();
                    if (!onClick) {
                        accountModalRef.current?.open();
                    }
                }}>
                <span>
                    {headingIcon && <Svg src={headingIcon} className="svg-icon" prefixAppName />}
                    {tId && <Translate tid={tId} namespace={TranslationScopes.UserAccount} />}
                    {titleStrongText && <strong>{titleStrongText}</strong>}
                </span>
            </div>
            {children}
        </div>
    );
};

export default AccountHeader;
